// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__81MGx","rootNoMargin":"styles_rootNoMargin__lewEH"};